function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Invalid URL. Please format as follows: '",
        "'"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "URL is required."
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "URL must start with https://"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import React from "react";
import styled from "styled-components";
import { Form, Input } from "antd";
import { t } from "ttag";
import { FacebookFilled, GlobalOutlined, LinkedinFilled, PictureOutlined, TwitterSquareFilled, VideoCameraOutlined } from "@ant-design/icons";
import Label from "./Label";
export var UrlTypes;
(function(UrlTypes) {
    UrlTypes["Facebook"] = "facebook";
    UrlTypes["Image"] = "image";
    UrlTypes["LinkedIn"] = "linkedin";
    UrlTypes["Twitter"] = "twitter";
    UrlTypes["Video"] = "video";
    UrlTypes["Website"] = "website";
})(UrlTypes || (UrlTypes = {}));
var ALLOWED_PROTOCOLS = [
    "http",
    "https"
];
var RETURN_KEY_CODE = 13;
var FACEBOOK_PATTERN = /^https:\/\/(www\.)?([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?facebook\.com\/([^\s])+$/;
var LINKEDIN_PATTERN = /^https:\/\/(www\.)?([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?linkedin\.com\/([^\s])+$/;
var TWITTER_PATTERN = /^https:\/\/(www\.)?([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?(twitter|x)\.com\/([^\s])+$/;
// eslint-disable-next-line no-useless-escape
var VIDEO_PATTERN = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#[\]@!\$&'\(\)\*\+,;=.]\/([^\s])+$/;
var Field = styled(Form.Item)(_templateObject());
export var enforceLinkProtocol = function(url) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _protocol_groups;
    if (!url) {
        return null;
    }
    var protocol = url.match(RegExp("(?<protocol>.+):\\/\\/"));
    // prepend https when the provided URL doesn't have one of the allowed protocols
    // its for keeping backward compatibility with previous implementation
    if (url !== "" && !ALLOWED_PROTOCOLS.includes(protocol === null || protocol === void 0 ? void 0 : (_protocol_groups = protocol.groups) === null || _protocol_groups === void 0 ? void 0 : _protocol_groups.protocol)) {
        return "https://".concat(url);
    }
    // prepend https when the provided URL doesn't have the secure protocol to social url
    if ((type === "twitter" || type === "linkedin" || type === "facebook") && url.startsWith("http://")) {
        return url.replace("http://", "https://");
    }
    return url;
};
var _obj;
var DATA = (_obj = {}, _defineProperty(_obj, UrlTypes.Website, {
    icon: /*#__PURE__*/ React.createElement(GlobalOutlined, null),
    sampleURL: "https://www.eventmobi.com",
    placeholder: "https://www.eventmobi.com/",
    type: "url"
}), _defineProperty(_obj, UrlTypes.Image, {
    icon: /*#__PURE__*/ React.createElement(PictureOutlined, null),
    sampleURL: "https://www.eventmobi.com/...",
    placeholder: "https://www.eventmobi.com/image.jpg",
    type: "url"
}), _defineProperty(_obj, UrlTypes.Twitter, {
    icon: /*#__PURE__*/ React.createElement(TwitterSquareFilled, null),
    sampleURL: "https://x.com/...",
    type: "string",
    pattern: TWITTER_PATTERN,
    placeholder: "https://x.com/EventMobi"
}), _defineProperty(_obj, UrlTypes.LinkedIn, {
    icon: /*#__PURE__*/ React.createElement(LinkedinFilled, null),
    sampleURL: "https://linkedin.com/company/...",
    type: "string",
    pattern: LINKEDIN_PATTERN,
    placeholder: "https://linkedin.com/company/eventmobi"
}), _defineProperty(_obj, UrlTypes.Facebook, {
    icon: /*#__PURE__*/ React.createElement(FacebookFilled, null),
    sampleURL: "https://facebook.com/...",
    type: "string",
    pattern: FACEBOOK_PATTERN,
    placeholder: "https://facebook.com/EventMobi"
}), _defineProperty(_obj, UrlTypes.Video, {
    icon: /*#__PURE__*/ React.createElement(VideoCameraOutlined, null),
    sampleURL: "https://youtube.com/...",
    type: "string",
    pattern: VIDEO_PATTERN,
    placeholder: "https://www.youtube.com/watch?v=video-id"
}), _obj);
var Url = function(param) {
    var _param_dependencies = param.dependencies, dependencies = _param_dependencies === void 0 ? [] : _param_dependencies, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_label = param.label, label = _param_label === void 0 ? "" : _param_label, name = param.name, _param_onKeyDown = param.onKeyDown, onKeyDown = _param_onKeyDown === void 0 ? undefined : _param_onKeyDown, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? null : _param_placeholder, _param_required = param.required, required = _param_required === void 0 ? false : _param_required, _param_requiredMessage = param.requiredMessage, requiredMessage = _param_requiredMessage === void 0 ? "" : _param_requiredMessage, _param_rules = param.rules, rules = _param_rules === void 0 ? undefined : _param_rules, setFieldValue = param.setFieldValue, type = param.type, validateFields = param.validateFields, _param_httpsOnly = param.httpsOnly, httpsOnly = _param_httpsOnly === void 0 ? false : _param_httpsOnly;
    var handleOnBlur = function() {
        var _ref = _asyncToGenerator(function(e) {
            var value, e1;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = e.currentTarget.value;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            validateFields([
                                name
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            setFieldValue(name, enforceLinkProtocol(value, type))
                        ];
                    case 3:
                        e1 = _state.sent();
                        return [
                            2,
                            null
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnBlur(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyPress = function() {
        var _ref = _asyncToGenerator(function(e) {
            var key;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        key = e.keyCode || e.which;
                        if (key !== RETURN_KEY_CODE) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            handleOnBlur(e)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleKeyPress(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var _DATA_type = DATA[type], icon = _DATA_type.icon, pattern = _DATA_type.pattern, ruleType = _DATA_type.type, defaultPlaceholder = _DATA_type.placeholder, sampleURL = _DATA_type.sampleURL;
    var urlRule = {
        message: t(_templateObject1(), sampleURL),
        transform: function(url) {
            return enforceLinkProtocol(url, type);
        },
        type: ruleType,
        pattern: pattern
    };
    return /*#__PURE__*/ React.createElement(Field, {
        dependencies: dependencies,
        label: label ? /*#__PURE__*/ React.createElement(Label, {
            isRequired: required
        }, label) : null,
        name: name,
        rules: [
            {
                required: required,
                message: requiredMessage !== null && requiredMessage !== void 0 ? requiredMessage : t(_templateObject2())
            },
            urlRule,
            httpsOnly ? {
                pattern: /^https:\/\//,
                message: t(_templateObject3())
            } : {},
            rules !== null && rules !== void 0 ? rules : {}
        ]
    }, /*#__PURE__*/ React.createElement(Input, {
        disabled: disabled,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : defaultPlaceholder,
        prefix: icon,
        onKeyPress: handleKeyPress,
        onKeyDown: onKeyDown,
        onBlur: handleOnBlur
    }));
};
export default Url;
